import { FormattedMessage } from 'react-intl';
import React from 'react';
import PropTypes from 'prop-types';

import { ContainedButton } from '../../../../Buttons';
import { isIOSorAndroid } from '../../../../../util/isHermesApp';

const EmptyInfoSection = ({ action, theme }) => {
    if (isIOSorAndroid()) {
        return null;
    }

    return (
        <div className={ theme.description }>
            <div className={ theme.additionalAction }>
                <ContainedButton
                    href={ action.href }
                    onClick={ action.onClick }
                    className={ theme.button }
                    testId={ action.testId }
                >
                    <FormattedMessage id="subscription.additionalAction.empty" />
                </ContainedButton>
            </div>
        </div>
    );
};

EmptyInfoSection.propTypes = {
    action: PropTypes.shape({
        href: PropTypes.string,
        className: PropTypes.string,
        onClick: PropTypes.func,
        testId: PropTypes.string,
    }),
    theme: PropTypes.shape({}),
};

export default EmptyInfoSection;
